import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_model`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The specific model, like `}<inlineCode parentName="td">{`gpt-5-mini`}</inlineCode>{` or `}<inlineCode parentName="td">{`claude-4-sonnet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_latency`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The latency of the LLM call in seconds`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_tools`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tools and functions available to the LLM`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_input`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of messages sent to the LLM`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_input_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of tokens in the input (often found in response.usage)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_output_choices`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of response choices from the LLM`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_output_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of tokens in the output (often found in `}<inlineCode parentName="td">{`response.usage`}</inlineCode>{`)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_total_cost_usd`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The total cost in USD (input + output)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/llm-analytics/generations#event-properties"
            }}>{`...`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`See `}<a parentName="td" {...{
              "href": "/docs/llm-analytics/generations#event-properties"
            }}>{`full list`}</a>{` of properties`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      